import styled from 'styled-components';
import { Modal } from 'reactstrap';
import { Button, Checkbox } from 'antd';
import { fadeIn } from '@/shared';

const StyledModal = styled(Modal)`
  .modal-content {
    border-radius: 0;

    .modal-body {
      @media only screen and (max-width: 550px) {
        font-size: 0.95rem;
      }

      i {
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          top: 0.2em;
        }
      }
    }

    .modal-header {
      > h5 {
        font-weight: 600;
      }

      .close {
        outline: 0;
        margin: -0.75rem -1rem -1rem auto;
      }
    }

    .modal-footer {
      button {
        width: 7rem;
      }
    }
  }
`;

const StyledAddTaskButton = styled(Button)`
  background-color: #efefef;
  border: 1px solid #efefef;
`;

const StyledHoursInput = styled.input`
  position: relative;
  display: inline-block;
  line-height: 1.5;
  width: 40px;
  height: 36px;
  text-align: center;
  background-clip: padding-box;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  box-sizing: border-box;
  border-radius: 0;
  border-style: solid;
  border-width: 1px;
  border-color: ${(props) => (props.invalid ? '#db011c' : '#ced4da')};

  :focus {
    border-color: ${(props) => (props.invalid ? '#db011c' : '#fe5d71')};
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(219, 1, 28, 0.25);
  }
`;

const StyledInlineErrorMessage = styled.div`
  font-size: 85%;
  color: #a80116;
  opacity: 0.75;
  filter: brightness(1.5);
  animation: ${fadeIn} 0.3s both ease-in-out;
`;

const StyledCheckbox = styled(Checkbox)`
  background-color: #efefef;
  border-color: red;
`;

export {
  StyledModal,
  StyledHoursInput,
  StyledAddTaskButton,
  StyledInlineErrorMessage,
  StyledCheckbox,
};
